import React, { useEffect, useRef } from 'react'
import fork from '../images/fork.svg'
import knife from '../images/knife.svg'
import glass from '../images/glass1.svg'
import bottle from '../images/wine.svg'
import arrowUp from '../images/arrowUp.svg';
import { motion, useScroll, useSpring } from "framer-motion";
import { BsInfoSquare } from 'react-icons/bs'
import { MdOutlineLanguage } from 'react-icons/md'


const Footer = ({ isEng, setIsEng, scrollYProgress, isFood, isFoodSetter, handleRefClick, closePromoBanner, handleShowInfoClick }) => {
    let scrollProgress

    if (scrollYProgress !== 0) {
        scrollProgress = (scrollYProgress + window.innerHeight) / document.documentElement.offsetHeight
    } else if (scrollYProgress === 0) {
        scrollProgress = 0.001
    }



    let animate = isFood ? { rotate: 45, translateX: 25 } : { rotate: 0, translateX: 0 }
    let animate2 = isFood ? { rotate: -45, translateX: -25 } : { rotate: 0, translateX: 0 }

    let animate3 = isFood ? { rotate: 0, translateX: 0 } : { rotate: 35, translateX: -15 }
    let animate4 = isFood ? { scale: 0 } : { scale: 1.2 }

    return (
        <div className='fixed -bottom-2 left-0 right-0  w-full border-t border-mainOne bg-beigeOne flex flex-col'>
            <motion.div className='progress-bar bg-mainThree' transition={{ duration: 0.2 }} style={{ scaleX: scrollProgress }} />


            <div
                className=' flex flex-row items-center w-full'>
                {/* <BsInfoSquare
                    onClick={() => handleShowInfoClick()}
                    className='text-mainTwo cursor-pointer ml-1 z-10 w-1/12' size={35} /> */}

                {/* FOOD AND DRINKS */}
                <div className='flex flex-row w-full mx-auto font-categories justify-center bg-mainOne'>
                    {/* FOOD */}
                    <div onClick={() => {
                        isFoodSetter(true)
                        closePromoBanner()
                        handleRefClick()
                    }}
                        className='flex flex-col mb-2 cursor-pointer'>
                        <div className={` mt-2 h-full flex flex-row  justify-space-between relative`}>
                            {isFood && <img className={` h-[50px] p-1 my-auto  border-mainTwo hover:bg-mainThree rounded-full mr-4`} src={arrowUp} />}
                            <div className='flex flex-col mr-2'>
                                <p className={`absolute ${isFood && 'border-b-3'} ${!isFood && 'font-not-bold'} font-category-button origin-center -rotate-[50deg] top-1/4 left-auto text-base text-mainTwo`}>
                                    {!isEng ? "Храни" : "Food"}
                                </p>
                            </div>
                            <div className='w-[130px] h-[60px] flex items-center'>
                                <div className={` -mr-16 w-[90px]`}>
                                    <motion.img
                                        initial={{ rotate: 0, translateX: 0 }}
                                        animate={animate}
                                        className='-mt-1 object-cover stroke-1 text-red-500 translate-x-5' src={fork} alt='fork' >
                                    </motion.img>
                                </div>
                                <div className='w-[90px] ml-3'>
                                    <motion.img
                                        initial={{ rotate: 0, translateX: 0 }}
                                        animate={animate2}
                                        className='-mt-1 object-cover -translate-x-5 z-5' src={knife}  alt='knife' />
                                </div>

                            </div>
                        </div>

                    </div>
                    {/* DRINKS */}
                    <div onClick={() => {
                        isFoodSetter(false)
                        closePromoBanner()
                        handleRefClick()
                    }}
                        className='flex w-[170px] flex-col mb-2 cursor-pointer'>
                        <div className={` mt-2 h-full flex flex-row  justify-center relative`} >
                            <div className='flex flex-col mr-10'>
                                <p className={`absolute ${!isFood && "border-b-3"} ${isFood && 'font-not-bold'} font-category-button origin-center
                                    -rotate-[50deg] top-1/4 left-auto text-base text-mainTwo`}>
                                    {!isEng ? "Напитки" : "Drink"}
                                </p>
                            </div>
                            <div className='w-[110px] h-[60px] flex items-center '>
                                <div className='-mr-14  w-[90px]'>
                                    <motion.img
                                        initial={{ rotate: 0, translateX: 0 }}
                                        animate={animate3}
                                        className='-mt-1 object-cover stroke-1 text-red-500 translate-x-5' src={glass} alt='fork' >
                                    </motion.img>
                                </div>
                                <div className='w-[90px] ml-3'>
                                    <motion.img
                                        initial={{ rotate: 0, translateX: 0 }}
                                        animate={animate4}
                                        className='-mt-1 object-cover -translate-x-5 z-5' src={bottle} alt='knife' />
                                </div>
                     
                            </div>
                            {!isFood && <img className='h-[50px] p-1 my-auto  border-mainTwo hover:bg-mainThree rounded-full ml-4 ' src ={arrowUp} /> }
                        </div>

                    </div>
                </div>
                {/* LANG SELECTOR */}
                {/* <div className='w-1/12 mr-1 flex flex-col justify-center items-center cursor-pointer z-10'
                    onClick={() => {
                        setIsEng(!isEng)
                    }}
                >
                    <MdOutlineLanguage className='text-mainTwo   ' size={35} />
                    <p className='text-2xl'>{!isEng ? 'ENG' : "BGN"}</p>
                </div> */}

            </div>
        </div>
    )
}

export default Footer